import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';
export var customDimensionIdMapping = {
    language: 1,
    country: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 3 : 2,
    businessUnit: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 5 : 3,
    product: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 7 : 4,
    segment: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 4 : 5,
    formIdentifier: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 6 : 6,
    formType: window.matomoUrl.includes('matomo.stg.cgm.punkt.hosting') ? 8 : 7,
};
export var useTrackPageWithCustomDimensions = function () {
    var trackPageView = useMatomo().trackPageView;
    // eslint-disable-next-line no-underscore-dangle
    var dataLayer = window._mtm;
    var customDimensions = [];
    dataLayer.forEach(function (dataLayerEntry) {
        var dataLayKey = Object.keys(dataLayerEntry)[0];
        var dataLayerValue = dataLayerEntry[dataLayKey];
        if (Object.keys(customDimensionIdMapping).includes(dataLayKey)) {
            customDimensions.push({ id: customDimensionIdMapping[dataLayKey], value: dataLayerValue });
        }
    });
    useEffect(function () {
        trackPageView({
            customDimensions: customDimensions,
        });
    }, []);
};
